import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { Loading } from '../../components/all'
import useInstrutorStore from '../../store/useInstrutorStore'

export default function HomeInstrutorView() {
  const { instrutor } = useInstrutorStore()
  const [loading, setLoading] = useState(false)
  const navigate = useNavigate()

  const alterPage = async (page) => {
    setLoading(true)
    try {
      if (instrutor.atividade_instrutor === true) {
        navigate(`/${page}`)
      }
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="min-h-screen flex flex-col items-center justify-center px-4">
      <div className="w-full max-w-md flex flex-col gap-6">
        {/* Header */}
        <div className="text-center">
          <p className="text-sm text-gray-500">Painel do instrutor</p>
          <h1 className="text-2xl font-bold capitalize mt-1">
            Bem-vindo, {instrutor.nome_instrutor}
          </h1>
        </div>

        {/* Cards de ação */}
        <div className="grid grid-cols-2 gap-4">
          <button
            onClick={() => alterPage('listAulasInstrutor')}
            className="
              bg-white rounded-2xl p-5 shadow-sm border border-gray-200
              flex flex-col items-center gap-2
              hover:shadow-md hover:border-primary/40 hover:scale-[1.02]
              active:scale-[0.97]
              transition-all duration-200
            "
          >
            <span className="material-icons text-primary text-4xl">
              directions_car
            </span>
            <span className="font-semibold">Aulas</span>
            <span className="text-xs text-gray-500">Ver agenda</span>
          </button>

          <button
            onClick={() => alterPage('listarAlunosInstrutor')}
            className="
              bg-white rounded-2xl p-5 shadow-sm border border-gray-200
              flex flex-col items-center gap-2
              hover:shadow-md hover:border-primary/40 hover:scale-[1.02]
              active:scale-[0.97]
              transition-all duration-200
            "
          >
            <span className="material-icons text-primary text-4xl">
              groups
            </span>
            <span className="font-semibold">Alunos</span>
            <span className="text-xs text-gray-500">Gerenciar</span>
          </button>
        </div>
      </div>

      <Loading visible={loading} />
      <ToastContainer position="top-center" />
    </div>
  )
}
